import { useTranslation } from '../../../utils/convergence'
import { TFunction } from 'i18next'
import React, { FunctionComponent, memo, ReactNode } from 'react'
import { Heading } from '@afterpaytouch/core'
import { useGetLocaleWithFallback } from '../../../utils/post-checkout'
import { useMerchantName } from '../../../state'
import { AssetChildComponentSpacing, MarginSize } from './types'
import { getSpacingClassName } from './helper'

interface Props extends AssetChildComponentSpacing {
  show?: boolean
}

export const Subtitle: FunctionComponent<Props> = memo(({ show = true, margin, marginBottom = MarginSize.x3, marginTop }) => {
  const { t } = useTranslation()
  const merchantDisplayName = useMerchantName() ?? t('postcheckout:asset:merchantDisplayNameDefault')
  const localeWithFallback = useGetLocaleWithFallback()

  const renderSubtitle = (t: TFunction): ReactNode => {
    const subtitle = t(localeWithFallback('subtitle'), '', {
      merchantDisplayName,
    })

    if (!show || subtitle.length === 0) {
      return null
    }

    return (
      <div className={getSpacingClassName({ margin, marginBottom, marginTop })}>
        <Heading size='M' testNameSpace='post-checkout-subtitle'>
          {subtitle}
        </Heading>
      </div>
    )
  }

  return <>{renderSubtitle(t)}</>
})
